// Categorical palette, fixed slot order: 0 = New users, 1 = Returning users,
// 2+ = categories in report order. Dark column = same hues re-stepped for a
// dark surface. Gray = total node + "Other".
export const SANKEY_PALETTE: Record<'light' | 'dark', string[]> = {
    light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
    dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
};
export const SANKEY_GRAY = '#898781';
export const MAX_LINES = 8;

export const fmt = (n: number | null | undefined): string =>
    (n ?? 0).toLocaleString('en-US');
export const pct = (part: number, whole: number): number =>
    !whole ? 0 : Math.round((1000 * part) / whole) / 10;

/** Comparison-column label: "WoW" only when the window is exactly 7 days. */
export const deltaLabel = (days: number): string =>
    days === 7 ? 'WoW' : `vs previous ${days} days`;

export interface DeltaParts { cls: string; text: string }
export const delta = (cur: number, prev: number): DeltaParts => {
    if (!prev) return cur ? { cls: 'pr-up', text: 'new' } : { cls: 'pr-flat', text: '—' };
    const change = pct(cur - prev, prev);
    if (change > 0) return { cls: 'pr-up', text: `▲ ${Math.abs(change)}%` };
    if (change < 0) return { cls: 'pr-down', text: `▼ ${Math.abs(change)}%` };
    return { cls: 'pr-flat', text: '▬ 0%' };
};
